import { Box, Button, Form, Icon, Spacer, Text } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import { FC, ReactElement, useEffect, useState } from 'react'
import { DefaultFormContainer } from '../../comps/DefaultFormContainer'
import { ModBox } from '../../comps/ModifiedBox/ModifiedBox'
import { forgotPwdStrings, loginStrings, staticStrings } from '../../data/static/strings'
import { useLazyApiData, useStores } from '../../data/store'
import { Routes } from '../../nav/routes'
import { isOsMobile, storeData, testProps, useWindowDimensions } from '../../util/util'
import { styles } from '../ForgotPassword/styles'
import { LoginBg } from '../Login/LoginBg'
import { formData } from './FormData'

interface SignupProps {
  hide?: boolean
}

export const leftComponent = (color: ColorOptions) => (
  <Box>
    <Text color={color ?? 'SECONDARY_GREY'} fontSize={12} fontFamily="JioType-Medium">
      +91
    </Text>
  </Box>
)

const Signup: FC<SignupProps> = ({ hide }: SignupProps) => {
  const viewPortWidth = useWindowDimensions()

  const { userObj, mobileNum, updateMobile } = useStores((root) => ({
    userObj: root.user.generateOtpOnSignup,
    mobileNum: root.settings.metaData.mobileNumber,
    updateMobile: root.settings.metaData.updateMobileNumber,
    generateSignUpOtp: root.user.generateSignUpOtp,
  }))
  const [generateOtp, { state, data }] = useLazyApiData(userObj)
  console.log('Sign up generateOtp data', data)

  const navigation = useNavigation()
  const [mobileNumberSelected, setMobileNumberSelected] = useState('')
  useEffect(() => {
    if (state === 'fulfilled') {
      navigation?.navigate(Routes.OTP, {
        path: Routes.OTP,
        isSignUp: true,
        mobileNum: mobileNum,
        isFromForgotPwd: false,
      })
    }
  }, [mobileNum, navigation, state])

  const themedStyle = styles

  const renderActionButtons = ({ handleSubmit, values, isValid }: any): ReactElement => {
    const handleResetPress = (): void => {
      handleSubmit()
      updateMobile(values.mobileNumber)
      storeData(loginStrings.userMobileNumber, values.mobileNumber)
      if (values.mobileNumber.length === 10 || isValid) {
        generateOtp(values.mobileNumber)
      }
    }
    return (
      <Box {...themedStyle.buttonContainer}>
        <Button
          isFull
          isLoading={state === 'pending'}
          disabled={values.mobileNumber.length !== 10}
          type={'primary'}
          {...testProps('signup-button')}
          onPress={handleResetPress}>
          <Text color={'WHITE'} fontWeight="bold">
            {forgotPwdStrings.proceed}
          </Text>
        </Button>
      </Box>
    )
  }

  const checkNGetNumberFromStorage = (): string => {
    return mobileNumberSelected !== '' ? mobileNumberSelected : mobileNum
  }

  const handleBack = (): void | undefined => {
    navigation?.goBack()
  }

  const leftComponent = () => (
    <Box>
      <Text color="SECONDARY_GREY" type="h2">
        +91
      </Text>
    </Box>
  )

  if (hide) {
    return null
  } else {
    return (
      <LoginBg isSignup={true}>
        <Box
          minWidth={viewPortWidth > 432 ? 320 : viewPortWidth - 36}
          minHeight={viewPortWidth > 432 ? 260 : undefined}
          justifyContent="center">
          <Box {...themedStyle.card}>
            <ModBox onPress={handleBack} show={isOsMobile()} {...testProps('back-button')} {...themedStyle.imgStyle}>
              <Icon id={'ARROW_BACK'} color={'PRIMARY'} size={24} />
            </ModBox>
            <Box pb={10} pt={5} underlayColor="WHITE">
              <Text {...themedStyle.titleStyle}>{staticStrings.signup}</Text>
            </Box>
            <Spacer size={5} />
            <Box {...themedStyle.formContainer}>
              <Form
                initialValues={{
                  mobileNumber: checkNGetNumberFromStorage(),
                }}
                container={DefaultFormContainer}
                formData={formData(leftComponent)}
                actionButtons={renderActionButtons}
              />
            </Box>
          </Box>
        </Box>
      </LoginBg>
    )
  }
}

export default Signup
